<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            {{ titulo }}
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-window v-model="step" show-arrows show-arrows-on-hover>   

                            <v-window-item :value="1">
                                <windowSegurosClienteComponent :listSeguros="_.get(listGeneral,'listSeguros',[])"
                                                               :idSeguro="_.toNumber(obSearch.idSeguro)"
                                />
                            </v-window-item>

                            <v-window-item :value="2">
                                <windowInformacionCertificadoComponent :listCertificados="_.get(listGeneral,'listCertificados',[])"
                                                                       :idCliente="obSearch.idCliente"
                                                                       :obBusqueda="obSearch"
                                                                       :active="step == 2 ? true : false"
                                />
                            </v-window-item>

                            <v-window-item :value="3">
                                <windowInformacionCoberturaComponent :listCoberturas="_.get(listGeneral,'listCoberturas',[])"
                                                                     :obBusqueda="obSearch"
                                                                     :active="step == 3 ? true : false"
                                                                     :parametros="parametros"
                                />
                            </v-window-item>

                            <v-window-item :value="4">
                                <windowInformacionBeneficioComplementarioComponent  :listBeneficios="_.get(listGeneral,'listBeneficios',[])"
                                                                                    :obBusqueda="obSearch"
                                                                                    :active="step == 4 ? true : false"
                                                                                    :parametros="parametros"
                                />
                            </v-window-item>

                            <v-window-item :value="5">
                                <windowInformacionAccesoriosComponent :listAccesorios="_.get(listGeneral,'listAccesorios',[])"
                                                                      :obBusqueda="obSearch"
                                                                      :active="step == 5 ? true : false"
                                                                      :parametros="parametros"
                                />
                            </v-window-item>

                            <v-window-item :value="6">
                                <windowDocumentosClienteComponent :listDocumentos="_.get(listGeneral,'listDocumentos',[])"
                                                                  :obBusqueda="obSearch"
                                                                  :active="step == 6 ? true : false"
                                                                  :parametros="parametros"
                                />
                            </v-window-item>

                        </v-window>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'ConsultaPolizaView',
        components: {
            windowSegurosClienteComponent: () => import('@/components/consulta/polizaCliente/windowSegurosClienteComponent.vue'),
            windowInformacionCertificadoComponent: () => import('@/components/consulta/polizaCliente/windowInformacionCertificadoComponent.vue'),
            windowInformacionCoberturaComponent: () => import('@/components/consulta/polizaCliente/windowInformacionCoberturaComponent.vue'),
            windowInformacionAccesoriosComponent: () => import('@/components/consulta/polizaCliente/windowInformacionAccesoriosComponent.vue'),
            windowInformacionBeneficioComplementarioComponent: () => import('@/components/consulta/polizaCliente/windowInformacionBeneficioComplementarioComponent.vue'),
            windowDocumentosClienteComponent: () => import('@/components/consulta/polizaCliente/windowDocumentosClienteComponent.vue')
        },
        data: () => ({
            step:1,
            listGeneral:{},
            parametros:{},
            obSearch:{
                idSeguro:null,
                idCliente:null
            },
        }),
        created(){
            var error = 'E';
            axios.post(`${BASE_URI}administrador/consulta-datos-poliza/cargaGeneral`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.$set(this.obSearch,'idCliente',_.get(this.$root.obUsuario,'idCliente',null));

                        var o = {
                            "opcion":"L_SEGUROS_X_CLIENTE",
	                        "idCliente": this.obSearch.idCliente
                        };
                        return axios.post(`${BASE_URI}administrador/consulta-datos-poliza/listar`,o)
                 })
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                        var l = _.cloneDeep(r.data.data);
                        
                        l = _.map(l,(v)=>{
                            v.foto = require(`@/assets/img/seguro/${v.idSeguro}.png`);
                            return v;
                        });

                        this.listGeneral.listSeguros = l;
                        this.obSearch.idSeguro = this.listGeneral.listSeguros[0].idSeguro;
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        computed:{
            titulo(){
                switch (this.step) {
                    case 1:
                    case 2:
                        return 'Consulta de Pólizas'
                        break;
                    case 3:
                        return `Consulta de Pólizas - Coberturas`
                        break;
                    case 4:
                        return `Consulta de Pólizas - Servicios Complementarios`
                        break;
                    case 5:
                        return `Consulta de Pólizas - Servicios Incluidos`
                        break;
                    case 6:
                        return `Consulta de Pólizas - Documentos`
                        break;
                }
            }
        },
        methods:{
            setStep(n){
                _.set(this,'step',n);
            },
            setData(Stringkey,data){
                var z = _.get(this,Stringkey,{});
                if(_.isArray(z))
                    _.set(this,Stringkey,data);
                else
                    _.set(this,Stringkey,_.merge({},z,data));
            }
        },
        provide(){
            return{
                setData: this.setData,
                setStep: this.setStep
            }
        }
    }
</script>
<style>
    .v-window__next{
        display: none;
    }

    .btnNext:hover{
        color: #FF4132;
    }
</style>